import React, { useContext } from 'react'
import './total.css'
import CalculatorContext from '../Context'

function Total() {
    const context = useContext(CalculatorContext);
    const {amount, price} = context;
    return (
        <div className="total-wrapper">
          <div className="total-element">
            <div className="total-number">
              <div className="dolar">$</div>
              <div className="number">{amount}</div>
              
            </div>
            <div className="subtext">Eliminate {(Number(amount) / price).toFixed(2)} tons 
            of greenhouse gases</div>            
          </div>
        </div>
        
    )
}

export default Total